import React, { Component } from 'react';
import AdminHeader from '../Header/AdminHeader';
import AdminFooter from '../Footer/AdminFooter';
import AdminLeftMenu from '../Navbar/AdminLeftMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import EmptyImg from "../Dashboard/assets/img/create-project.png";

import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';
import { userloginDetails } from '../Utils/AdminAuth';
import { HOST_URL } from '../Dashboard/api/Api';

class ApiRequest extends Component {

    constructor(props) {

        const lStorage = userloginDetails();
        const userId = lStorage?.user?.userId;
        const userToken = lStorage?.token;

        super(props);

        this.state = {
            user_id: userId,
            token: userToken,
            allUserList: null,
            searchData: this.props.match.params.username,
            userCurrentStatus: '',
            successMessage: false,
            errorMessage: '',
            bgColor: "alert alert-success alert-dismissible",
        }

    }

    componentDidMount() {
        if (this.props.match.params.username) {
            this.searchUser();
        } else {
            this.onserch();
        }


    }

    onserch() {
        const payload = {
            user_id: this.state.user_id,
            method: "apirequest",
            type: "admin",
            token: this.state.token,
        };

        fetch(`${HOST_URL}/admin_dashboard.php`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.success === true) {
                    this.setState({
                        allUserList: result,
                        userCurrentStatus: result.data[0].is_active
                    });
                } else {
                    this.setState({
                        successMessage: true,
                        successBg: "alert alert-danger alert-dismissible",
                        errorMessage: result.message,
                    });
                }
            })
            .catch((error) => {
                console.error("Error in onserch:", error);
            });
    }

    searchUser() {
        if (this.state.searchData === '') {
            this.onserch();
            this.setState({
                successMessage: true,
                errorMessage: "Enter User Name ",
                bgColor: "alert alert-danger alert-dismissible"
            });
        } else {
            const payload = {
                user_id: this.state.user_id,
                method: "apirequest",
                type: "search",
                username: this.state.searchData,
                token: this.state.token,
            };

            fetch(`${HOST_URL}/admin_dashboard.php`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.success === true) {
                        this.setState({
                            successMessage: false,
                            allUserList: result
                        });
                    } else {
                        this.setState({
                            successMessage: true,
                            errorMessage: result.message,
                            bgColor: "alert alert-danger alert-dismissible"
                        });
                    }
                })
                .catch((error) => {
                    console.error("Error in searchUser:", error);
                });
        }
    }



    render() {
        // console.log('searchData',this.state.searchData)

        return (
            <div className="wrapper">
                <AdminLeftMenu />
                <div className="main">
                    <AdminHeader />
                    <main className="content">
                        <div className="container-fluid p-0">
                            <div className="row mb-2 mb-xl-3">
                                <div className="col-auto d-none d-sm-block">
                                    <h3><strong> User API </strong> Request </h3>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                                    <div className="card flex-fill">

                                        <div className="card-header">

                                            <h5 className="card-title mb-0"> List of User API Request </h5>
                                        </div>

                                        <div className="card-body">
                                            <div className="filter-option">

                                                <h6 className="card-subtitle text-muted">Filter </h6>

                                                <div className="row">
                                                    <div className="col-md-8">
                                                        <div className="input-group mb-2 mr-sm-2">
                                                            <div className="input-group-text"><FontAwesomeIcon icon={faSearch} /></div>
                                                            <input type="text" defaultValue={this.state.searchData} onChange={(event) => { this.setState({ searchData: event.target.value }) }} placeholder="Enter user id or name of users" className="form-control" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 text-center">
                                                        <div className="input-group mb-2 mr-sm-2">
                                                            <input type="button" onClick={() => this.searchUser()} value="Search" className="btn mt-1 btn-block btn-primary btn-sm ml-auto  " />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                this.state.successMessage ?
                                                    <div className={this.state.bgColor} role="alert">
                                                        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                            <span aria-hidden="true">×</span>
                                                        </button>
                                                        <div className="">
                                                            {this.state.errorMessage}
                                                        </div>
                                                    </div>
                                                    :
                                                    null
                                            }

                                            {this.state.allUserList ?

                                                <div style={{ height: 400 + 'px' }} className="table-responsive">
                                                    <table className="table table-striped table-xs table-sm my-0">
                                                        <thead className="sticky-top">
                                                            <tr>
                                                                <th> Email ID / Username</th>
                                                                <th> Request </th>
                                                                <th>Created  </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            {
                                                                this.state.allUserList.data.map((item, i) =>

                                                                    <tr key={i}>
                                                                        <td>{item.username}</td>
                                                                        <td><JSONPretty id="json-pretty" data={item.request_str}></JSONPretty></td>

                                                                        <td>{item.created}</td>
                                                                    </tr>

                                                                )
                                                            }


                                                        </tbody>
                                                    </table>
                                                </div>
                                                :
                                                <div className="text-center">
                                                    <div className="card-body">
                                                        <img alt="Empty Data" className="project-empty-img" src={EmptyImg} />
                                                        <p>No Any History </p>

                                                    </div>
                                                </div>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                    <AdminFooter />
                </div>
            </div>

        );
    }
}
export default ApiRequest;